<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
    <form @submit.prevent="confirmBeforeSubmit(validate)">
      <!-- Slots pour les champs personnalisables -->
      <slot :form-data="formData" :is-editing="isEditing"></slot>

      <div class="form-group text-end mt-3">
        <button type="button" class="btn btn-gray me-2" @click="$emit('cancel')">Annuler</button>
        <button type="submit" class="btn btn-success" :disabled="invalid">
          <span class="fe" :class="isEditing ? 'fe-edit' : 'fe-check'"></span>
          {{ isEditing ? 'Modifier' : 'Enregistrer' }}
        </button>
      </div>

      <!-- Modal de confirmation -->
      <div class="modal fade" ref="confirmModal" tabindex="-1">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirmation</h5>
              <button type="button" class="close" data-bs-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Êtes-vous sûr de vouloir {{ isEditing ? 'modifier' : 'enregistrer' }} ces informations ?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
              <button type="button" class="btn btn-primary" @click="submitForm">Confirmer</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
  export default {
    name: "GenericForm",
    props: {
      value: Object,
      isEditing: Boolean
    },
    data() {
      return {
        formData: { ...this.value }
      };
    },
    methods: {
      confirmBeforeSubmit(validateFn) {
        validateFn().then((valid) => {
          if (valid) {
            $(this.$refs.confirmModal).modal("show");
          }
        });
      },
      submitForm() {
        $(this.$refs.confirmModal).modal("hide");
        this.$emit("submit", { ...this.formData });
      }
    },
    watch: {
      value(newVal) {
        this.formData = { ...newVal };
      }
    }
  };
</script>
